import React from 'react';
import { motion } from 'framer-motion';
export function CosmicBackground() {
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" data-id="element-211">
      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-hubble-paper/5 via-hubble-ink to-hubble-ink" data-id="element-212"></div>

      {/* Star dots pattern */}
      <div className="absolute inset-0 opacity-[0.05]" style={{
      backgroundImage: `radial-gradient(circle at center, #F2EFE9 1px, transparent 1px)`,
      backgroundSize: '48px 48px'
    }} data-id="element-213"></div>

      {/* Large orbital rings */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-[1200px] h-[800px] opacity-20" data-id="element-214">
        <motion.div animate={{
        rotate: 360
      }} transition={{
        duration: 150,
        repeat: Infinity,
        ease: 'linear'
      }} className="absolute top-[-20%] left-1/2 -translate-x-1/2 w-[1200px] h-[1200px] border border-hubble-paper/10 rounded-full" data-id="element-215" />
        <motion.div animate={{
        rotate: -360
      }} transition={{
        duration: 200,
        repeat: Infinity,
        ease: 'linear'
      }} className="absolute top-[-10%] left-1/2 -translate-x-1/2 w-[900px] h-[900px] border border-hubble-paper/5 rounded-full" data-id="element-216" />
        <motion.div animate={{
        rotate: 360
      }} transition={{
        duration: 100,
        repeat: Infinity,
        ease: 'linear'
      }} className="absolute top-[0%] left-1/2 -translate-x-1/2 w-[600px] h-[600px] border border-hubble-signal/10 rounded-full" data-id="element-217" />
      </div>

      {/* Glow effects */}
      <div className="absolute top-[-10%] left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-hubble-signal/5 blur-[120px] rounded-full" data-id="element-218"></div>
    </div>;
}